/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_AskInputs */

const en_us2_plan_edit_ask = /** @type {(inputs: Plan_Edit_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the trainer`)
};

const pt_br2_plan_edit_ask = /** @type {(inputs: Plan_Edit_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao personal`)
};

const es_419_plan_edit_ask = /** @type {(inputs: Plan_Edit_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntar al entrenador`)
};

const pt_pt2_plan_edit_ask = /** @type {(inputs: Plan_Edit_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao treinador`)
};

const fr_fr2_plan_edit_ask = /** @type {(inputs: Plan_Edit_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander au coach`)
};

const de_de2_plan_edit_ask = /** @type {(inputs: Plan_Edit_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach fragen`)
};

const it_it2_plan_edit_ask = /** @type {(inputs: Plan_Edit_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi al coach`)
};

/**
* | output |
* | --- |
* | "Ask the trainer" |
*
* @param {Plan_Edit_AskInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_ask = /** @type {((inputs?: Plan_Edit_AskInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_AskInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_ask(inputs)
	if (locale === "es-419") return es_419_plan_edit_ask(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_ask(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_ask(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_ask(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_ask(inputs)
	return en_us2_plan_edit_ask(inputs)
});
export { plan_edit_ask as "plan-edit.ask" }